<template>
  <div>
    <ServiceTicketForm
        :providedContact="providedContact"
        :busy="isBusy"
        saveLabel="Save"
        @save="createServiceTicket"
    />
    <ServiceTicketCreated
        ref="createdDialog"
        :ticket="createdTicket"
        @done="onDone"
    />
  </div>
</template>

<script>
import ServiceTicketForm from "@/components/ServiceTickets/ServiceTicketForm.vue";
import ServiceTicketCreated from "@/components/ServiceTickets/ServiceTicketCreated.vue";
import notificationMixin from "@/mixins/notificationMixin";

export default {
  name: "CreateServiceTicket",
  mixins: [notificationMixin],
  components: {
    ServiceTicketForm,
    ServiceTicketCreated,
  },
  props: {
    providedContact: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isBusy: false,
      createdTicket: null,
    };
  },
  methods: {
    async createServiceTicket(payload) {
      this.isBusy = true;
      try {
        const result = await this.ServiceTicketService.logServiceTicket(payload);
        this.createdTicket = result;
        this.notifySuccess("Logged Service Ticket successfully.");
        this.$refs.createdDialog.open();
      } catch (error) {
        console.error(error);
        this.notifyError(this.saveErrorMessage(error));
      } finally {
        this.isBusy = false;
      }
    },
    saveErrorMessage(error) {
      const message = error && error.data ? error.data.message : null;
      if (Array.isArray(message) && message.length) return message.join(" ");
      if (typeof message === "string" && message) return message;
      return "There's been an error whilst logging this service ticket.";
    },
    onDone() {
      this.$emit("complete", this.createdTicket);
      this.createdTicket = null;
    },
  },
};
</script>
